import { getGatewayProductFamily } from './gatewayProductLabel';

export function normalizeGatewayMacHex(gateway) {
  const raw = gateway?.gateway_mac_hex || gateway?.mac_address || '';
  return String(raw).replace(/[^0-9A-Fa-f]/g, '').toUpperCase();
}

export function getGatewayTopicPrefix(gateway) {
  return getGatewayProductFamily(gateway) === 'KGateway' ? 'kbeacon' : 'lilygo';
}

/** MQTT admin + data topics for any gateway type (KGateway, LGateway, MGateway). */
export function resolveGatewayMqttTopics(gateway) {
  const macHex = normalizeGatewayMacHex(gateway);
  const topicPrefix = getGatewayTopicPrefix(gateway);
  const lastCfg =
    gateway?.last_known_config && typeof gateway.last_known_config === 'object'
      ? gateway.last_known_config
      : {};

  return {
    macHex,
    topicPrefix,
    publishTopic:
      String(gateway?.mqtt_pub_topic || gateway?.mqtt_topic || lastCfg.pubtopic || '').trim() ||
      `${topicPrefix}/publish/${macHex}`,
    subActionTopic:
      String(gateway?.mqtt_sub_topic || lastCfg.subtopic || '').trim() ||
      `${topicPrefix}/subaction/${macHex}`,
    pubActionTopic:
      String(lastCfg.pubaction || '').trim() || `${topicPrefix}/pubaction/${macHex}`,
    subAdminTopic:
      String(gateway?.mqtt_admin_sub_topic || lastCfg.subadmintopic || '').trim() ||
      `${topicPrefix}/subadmin/${macHex}`,
    pubAdminTopic:
      String(gateway?.mqtt_admin_pub_topic || lastCfg.pubadmintopic || '').trim() ||
      `${topicPrefix}/pubadmin/${macHex}`,
  };
}

/** Same admin getCfg payload for all gateway families (KKM / LilyGO / LOLIN). */
export function buildGetCfgCommand(seq = 1) {
  return {
    msg: 'admin',
    stype: 'getCfg',
    seq,
    user: 'admin',
    pwd: 'admin',
    cfgMask: 0xffff,
    includeCreds: 1,
  };
}
